import { Injectable, inject } from "@angular/core";
import type { ActivatedRouteSnapshot, Resolve } from "@angular/router";

import { type Observable, of } from "rxjs";

import { LoadTranslationService } from "../services/load-translations.service";

interface SectionData {
  section?: string;
}

@Injectable({ providedIn: "root" })
/**
 * Resolver that loads translations for a specific section before route activation.
 */
export class TranslationsResolver implements Resolve<boolean> {
  private loadTranslateService = inject(LoadTranslationService);

  /**
   * Resolves translations loading for the current route.
   * @param {ActivatedRouteSnapshot} route - The activated route snapshot containing route data
   * @returns {Observable<boolean>} Observable that emits true when translations are loaded or immediately if no section is specified
   */
  resolve(route: ActivatedRouteSnapshot): Observable<boolean> {
    const { section } = route.data as SectionData;

    if (!section) {
      return of(true);
    }
    return this.loadTranslateService.loadTranslations(section);
  }
}
